/* src/app/modules/investment/intangible-material/investment.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
li {
  list-style-type: none;
  margin: auto 10px;
}
th,
td {
  padding: 5px;
}
table {
  border-collapse: separate;
  border-spacing: 5px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
th,
td {
  vertical-align: top;
}
table {
  margin: 0 auto;
}
.pdf-container {
  height: 80vh;
}
.flex-container.investment-form-container .second-column {
  width: 40%;
}
.flex-container.investment-form-container .first-column .imageFile {
  max-width: 70%;
  max-height: none;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .flex-container.investment-form-container .first-column .imageFile {
    max-width: 100%;
  }
  .pdf-image-file {
    max-width: 100% !important;
  }
}
@media (max-width: 991px) {
  .flex-container.investment-form-container .second-column {
    width: 30%;
  }
}
@media (max-width: 767px) {
  .flex-container.investment-form-container {
    flex-direction: column;
  }
  .flex-container.investment-form-container .second-column {
    width: 100%;
  }
  .flex-container.investment-form-container .first-column {
    width: 100%;
  }
}
.if-layout {
  display: grid;
  gap: 0 24px;
  align-items: start;
}
.if-layout--3 {
  grid-template-columns: 1fr 1fr 1fr;
}
.if-layout--2 {
  grid-template-columns: 1fr 1fr;
}
.if-layout--wide {
  grid-template-columns: 1fr 1.4fr;
}
.if-col {
  display: flex;
  flex-direction: column;
}
.if-field {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  width: 100%;
}
.if-field mat-form-field,
.if-field app-autocomplete-select {
  flex: 1;
  min-width: 0;
}
.if-field app-help {
  margin-top: 14px;
  flex-shrink: 0;
}
.if-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
  padding: 14px 0 8px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
}
.if-total {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  padding: 10px 0 4px;
}
.if-file-area {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.if-file-preview {
  background: #f8f9fb;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.if-file-preview .imageFile {
  width: 100% !important;
  height: auto !important;
  max-height: 360px;
  object-fit: contain;
}
.if-file-preview .pdf-container {
  width: 100%;
  height: 50vh;
}
.if-import-info {
  background: #f3f4f6;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 8px;
  font-size: 13px;
  color: #374151;
}
@media (max-width: 768px) {
  .if-layout--3,
  .if-layout--2,
  .if-layout--wide {
    grid-template-columns: 1fr;
  }
}
.if-dlg {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 88vh;
  overflow: hidden;
}
.if-dlg__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
  background: #fff;
}
.if-dlg__head-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.if-dlg__icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.if-dlg__icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.if-dlg__title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}
.if-dlg__saved {
  color: #16a34a;
  font-size: 20px;
}
.if-dlg__body {
  flex: 1;
  overflow-y: auto;
  background: #f8f9fb;
  padding: 16px 20px;
}
.if-dlg__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0;
}
.if-btn-save {
  background: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center;
  gap: 5px;
  box-shadow: 0 1px 4px rgba(227, 253, 100, .28) !important;
}
.if-btn-cancel {
  border-radius: 8px !important;
}
.if-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .03);
}
.if-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafbfc;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
}
.if-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: #e3fd64;
}
.if-section__body {
  padding: 14px 14px 8px;
}
.if-dlg .if-layout {
  gap: 14px;
}
.if-dlg .if-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.if-section__body ::ng-deep .mdc-notched-outline {
  height: 44px;
}
.if-section__body ::ng-deep .mat-mdc-form-field-infix {
  padding: 10px 0;
  min-height: 44px;
}
.if-section__body ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.if-section__body ::ng-deep textarea.mat-mdc-input-element {
  margin: 4px 0;
}
.if-section__body .if-field app-help {
  margin-top: 12px;
}
.if-import-banner {
  background: rgba(227, 253, 100, .08);
  border: 1px solid rgba(227, 253, 100, .25);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  color: #374151;
  margin-bottom: 12px;
}
/*# sourceMappingURL=investment.component.css.map */
